module.exports = __webpack_public_path__ + "static/img/museen-nord.6855625.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/museen-nord.png
// module id = JujR
// module chunks = 0